'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var VerifyEmail = _react2['default'].createClass({
    displayName: 'VerifyEmail',


    propTypes: {
        'shortGuid': _react2['default'].PropTypes.string,
        'emailAddress': _react2['default'].PropTypes.string,
        'csrf_token': _react2['default'].PropTypes.string
    },

    getInitialState: function getInitialState() {
        return {
            processing: false
        };
    },
    onSuccess: function onSuccess() {
        this.setState({ processing: false });
    },
    onResendClick: function onResendClick(e) {

        e.preventDefault();
        var self = this;

        this.setState({ processing: true });

        var resendAddress = '/signer/sendTemplateLinkEmail';

        _superagent2['default'].post(resendAddress).type('form').send({ email_address: this.props.emailAddress }).send({ guid: this.props.shortGuid }).send({ csrf_token: this.props.csrf_token }).end(function (err, res) {
            if (!err) {
                var data = JSON.parse(res.text);
                self.onSuccess(data);
            }
        });
    },
    render: function render() {
        var spinner = this.state.processing ? _react2['default'].createElement('img', {
            className: 'spinner',
            style: { position: 'absolute', left: '10%' },
            src: require('ui/signature-modal/loading-spinner-16.gif'),
            width: '16',
            height: '16' }) : void 0;

        return _react2['default'].createElement(
            'div',
            { className: 'm-verify-email row' },
            _react2['default'].createElement(
                'div',
                { className: 'm-verify-email--container' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-verify-email--text' },
                    _react2['default'].createElement(
                        'h4',
                        null,
                        'One last thing'
                    ),
                    _react2['default'].createElement('img', { src: require('./email_icon@2x.png') }),
                    _react2['default'].createElement(
                        'div',
                        null,
                        'We just sent you an email.'
                    ),
                    _react2['default'].createElement(
                        'div',
                        null,
                        'Please open it and click \'Review Document\'.'
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-verify-email--resend' },
                    spinner,
                    'Don\'t see it in your inbox? ',
                    _react2['default'].createElement(
                        'a',
                        { href: '#', onClick: this.onResendClick },
                        'Click here to resend.'
                    )
                )
            ),
            _react2['default'].createElement(
                'span',
                { className: 'm-verify-email--legal' },
                'Note: This step is required to comply with eSignature laws.'
            )
        );
    }
});

module.exports = VerifyEmail;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/auth/verify-email.jsx
 ** module id = 884
 ** module chunks = 0
 **/